import { lumiApi } from "../index";

export const projectsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getLLMPassThrough: build.mutation({
            query: ({ projectId, prompt }) => ({
                url: `/projects/${projectId}/chatbot/llm_passthrough/`,
                method: "POST",
                body: { prompt },
            }),
            transformResponse: (response) => response,
        }),
    }),
});

export const {
    useGetLLMPassThroughMutation
} = projectsApi;